import { useState, useEffect } from "react"
import nodeApiService from "../../services/nodeApiService"
import { removeEmptyFromObject } from "../../services/utils/removeEmptyFromObject"
import { sorts } from "../../services/utils/sorts"
import { useInfinitePagination } from "./useInfinitePagination"

export const useGalleriesAction = (galleriesData, searchTerm = null) => {
  const [galleries, setGalleries] = useState(galleriesData)
  const _sorts = sorts.galleries
  const [sort, setSort] = useState(null)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState(searchTerm)
  const { loadingMore, setPage, setShouldCall } = useInfinitePagination(
    (page) => callApi(page),
    (response) =>
      setGalleries({
        ...galleries,
        data: [...galleries.data, ...response.data],
      }),
  )

  const callApi = (page) => {
    const body = removeEmptyFromObject({ search, page, order: sort })
    if (Object.keys(body).length !== 0) {
      return nodeApiService.galleries(body)
    }
  }

  useEffect(() => {
    if (search !== null || sort !== null) {
      setPage(1)
      setLoading(true)
      setShouldCall(true)
      callApi().then((response) => {
        setGalleries(response.data)
        setLoading(false)
      })
    }
  }, [search, sort])

  return {
    galleries,
    setSearch,
    loading,
    loadingMore,
    sort,
    setSort,
    sorts: _sorts,
  }
}
